import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import rootReducer from "../reducers";
// Redux Persist Configuration
const persistConfig = {
  key: "root",
  storage,
  blacklist: ["dateRange"], // exclude being persisted
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create store with configureStore from Redux Toolkit
export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disable serializable check for redux-persist
    }),
});

// Setup Redux Persist
export const persistor = persistStore(store);
